// extracted by mini-css-extract-plugin
export default {"section":"Stack_section__3rNr+","inner":"Stack_inner__cLYAw","grid":"Stack_grid__686rX","cell":"Stack_cell__IlGiO","card":"Stack_card__ZPz80","cardTitle":"Stack_cardTitle__Q7aAP"};